var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRectangleLight = function SvgRectangleLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.045,
    height: 30.85,
    viewBox: "0 0 25.045 30.85"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_200",
    "data-name": "Union 200",
    d: "M12.476,30.821Q6.245,23.129,0,15.453c2.226-2.816,4.534-5.589,6.786-8.394C8.708,4.713,10.608,2.336,12.533,0c4.194,5.113,8.334,10.278,12.512,15.406-.577.879-1.355,1.668-1.992,2.523-3.521,4.3-7.007,8.632-10.538,12.92Z",
    fill: "#ffebc3"
  })));
};

export { SvgRectangleLight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNS4wNDUiIGhlaWdodD0iMzAuODUiIHZpZXdCb3g9IjAgMCAyNS4wNDUgMzAuODUiPgogIDxwYXRoIGlkPSJVbmlvbl8yMDAiIGRhdGEtbmFtZT0iVW5pb24gMjAwIiBkPSJNMTIuNDc2LDMwLjgyMVE2LjI0NSwyMy4xMjksMCwxNS40NTNjMi4yMjYtMi44MTYsNC41MzQtNS41ODksNi43ODYtOC4zOTRDOC43MDgsNC43MTMsMTAuNjA4LDIuMzM2LDEyLjUzMywwYzQuMTk0LDUuMTEzLDguMzM0LDEwLjI3OCwxMi41MTIsMTUuNDA2LS41NzcuODc5LTEuMzU1LDEuNjY4LTEuOTkyLDIuNTIzLTMuNTIxLDQuMy03LjAwNyw4LjYzMi0xMC41MzgsMTIuOTJaIiBmaWxsPSIjZmZlYmMzIi8+Cjwvc3ZnPgo=";